export default __webpack_public_path__ + "static/media/8.e432593b.jpg";